import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import PropTypes from 'prop-types';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorScreen from '../components/Errors/ErrorScreen';

const Layout = (props) => {
  return (
    <div className="layout-container">
      {!props.hideHeader && <Header />}
      <ErrorBoundary FallbackComponent={ErrorScreen}>
        <Outlet />
      </ErrorBoundary>
      <div className="layout-flex-grow" />
      <Footer />
    </div>
  );
};
export default Layout;
Layout.propTypes = {
  hideHeader: PropTypes.bool,
};
